// @flow
import { pickBy } from 'lodash'

export const getArticleContents = (state: Object, articleId: string): any => {
  return pickBy(state.articleContents.resources, (articleContent) => articleContent.article === articleId)
}
